export enum RequirementStatusEnum {
  Open = 1,
  Complete = 2,
}

export interface RequirementModalHeader {
  Carrier: string | null,
  Product: string | null,
  PolicyStatus: string | null
}